import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import objectHash from 'object-hash';
import React from 'react';
import getVideoId from 'get-video-id';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Cookies, withCookies } from 'react-cookie';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Snackbar from '@material-ui/core/Snackbar';
import NoSsr from '@material-ui/core/NoSsr';
import Button from '@material-ui/core/Button';
import NoteAdd from '@material-ui/icons/NoteAdd';

import * as lessonDetailsActions from '../../../actions/lessonDetails';

import VideoPlayer from '../../../components/VideoPlayer/VideoPlayer';
import { isIOS } from '../../../helpers';
import isMobileUserAgent from '../../../helpers/checkMobileUserAgent';
import isLoggedIn from '../../../helpers/checkAuth';
import history from '../../../history';
import Intercom from '../../../widgets/Intercom';
import GoToNextSection from '../GoToNextSection/GoToNextSection';
import VideoNotePopover from '../VideoNotePopover/VideoNotePopover';

import messages from '../lessonDetailsMessages';

import s from './Video.scss';

@injectIntl
@withCookies
@withStyles(s)
@connect(
  state => ({
    auth: state.auth,
    lesson: state.lessonDetails.lesson,
    course: state.courseDetails.course,
    videoNotes: state.lessonDetails.videoNotes,
    totalTranscodingJobs: state.transcodingJobs.total,
    lang: state.intl.locale,
    offline: state.online.offline,
    isPlayerLoaded: state.lessonDetails.isPlayerLoaded,
    isNotesShown: state.lessonDetails.isNotesShown,
    loadingVideoNotes: state.lessonDetails.loadingVideoNotes,
  }),
  dispatch =>
    bindActionCreators(
      {
        updateState: lessonDetailsActions.updateState,
      },
      dispatch,
    ),
)
class Video extends React.Component {
  static propTypes = {
    auth: PropTypes.shape({
      user: PropTypes.shape({}),
    }),
    complete: PropTypes.func.isRequired,
    lesson: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      videos: PropTypes.arrayOf(PropTypes.shape({})),
      youtubeVideoUrl: PropTypes.string,
      isSharedToWhitelabeledOrg: PropTypes.bool,
      isCompleted: PropTypes.bool,
    }).isRequired,
    course: PropTypes.shape({
      _id: PropTypes.string,
      slug: PropTypes.string,
    }).isRequired,
    intl: intlShape.isRequired,
    cookies: PropTypes.instanceOf(Cookies).isRequired,
    videoFullPage: PropTypes.bool.isRequired,
    handleChangeVideoFullPage: PropTypes.func.isRequired,
    updateState: PropTypes.func.isRequired,
    videoNotes: PropTypes.array.isRequired,  // eslint-disable-line
    nextUrl: PropTypes.string,
    nextItem: PropTypes.object, // eslint-disable-line
    query: PropTypes.object, // eslint-disable-line
    contentTypeSwitchers: PropTypes.shape({
      video: PropTypes.bool.isRequired,
      audio: PropTypes.bool.isRequired,
      text: PropTypes.bool.isRequired,
    }).isRequired,
    totalTranscodingJobs: PropTypes.number.isRequired,
    playerRef: PropTypes.func,
    playFrom: PropTypes.number,
    lang: PropTypes.string.isRequired,
    className: PropTypes.string,
    offline: PropTypes.bool.isRequired,
    isPlayerLoaded: PropTypes.bool.isRequired,
    isNotesShown: PropTypes.bool.isRequired,
    loadingVideoNotes: PropTypes.bool.isRequired,
    isLessonReviewFocused: PropTypes.bool,
    videoStop: PropTypes.bool,
    thumbnailVimeoImg: PropTypes.string,
  };

  static defaultProps = {
    query: {},
    playerRef: () => null,
    playFrom: undefined,
    nextItem: undefined,
    nextUrl: undefined,
    auth: {},
    className: '',
    isLessonReviewFocused: false,
    videoStop: false,
    thumbnailVimeoImg: '',
  };

  static contextTypes = {
    cloudfrontUrl: PropTypes.string,
    organizationSlug: PropTypes.string,
    whitelabeling: PropTypes.shape({}),
  };

  state = {
    goToNextSectionItemProgress: 0,
    isSnackBarShown: false,
    isAddVideoNoteOpen: false,
    videoNoteTime: 0,
  };

  player = null;

  componentDidMount() {
    setTimeout(() => {
      if (!_.has(this.props.query, 'showEvaluationModal')) {
        this.setState({ isSnackBarShown: this.props.videoFullPage });
      }
    }, 1000);
  }

  componentWillReceiveProps(nextProps) {
    if (
      objectHash(_.get(this, 'props.videoNotes', [])) !==
      objectHash(_.get(nextProps, 'videoNotes', []))
    ) {
      this.updateVideoNotes(nextProps.videoNotes);
    }

    if (
      this.props.isLessonReviewFocused !== nextProps.isLessonReviewFocused &&
      nextProps.isLessonReviewFocused
    ) {
      if (this.player && !this.player.ended()) {
        this.player.pause();
      } else {
        this.cancelGoToNextSectionItem();
      }
    }

    if (
      this.props.videoStop !== nextProps.videoStop &&
      !nextProps.videoStop &&
      !isIOS() &&
      this.player &&
      !this.player.ended()
    ) {
      this.player.play().catch(err => console.error(err));
      this.setState({ isSnackBarShown: this.props.videoFullPage });
    }
  }

  onVideoPlayerUnmount = () => {
    if (this.player) {
      try {
        // this.player.pause(); // todo take a look a this
        this.removeVideoPlayerEvents();
        this.cancelGoToNextSectionItem();
        // this.player.dispose();
      } catch (error) {
        console.error(error);
      }
    }
  };

  onVideoClick = () => {
    this.props.handleChangeVideoFullPage(false, () => {
      if (_.get(this, 'player.resizeVideoJS')) {
        this.player.resizeVideoJS();
      }
    });
    this.props.cookies.set(
      'contentTypeSwitchers',
      this.props.contentTypeSwitchers,
      { path: '/', domain: window.App.cookieDomain },
    );
    if (!isMobileUserAgent()) {
      Intercom.boot(this.props.auth.user, this.context.whitelabeling);
    }
  };

  onVideoPlayerSetup = player => {
    const {
      intl: { formatMessage },
      totalTranscodingJobs,
      lesson,
    } = this.props;

    if (
      totalTranscodingJobs &&
      !_.get(lesson, 'videos.length') &&
      !lesson.youtubeVideoUrl
    ) {
      player.$('.vjs-poster').classList.add('vjs-transcoding');
      player.$( // eslint-disable-line
        '.vjs-poster',
      ).innerHTML = `<div class="vjs-transcoding-spinner"></div><div class="vjs-transcoding-content">${formatMessage(
        messages.isTranscoding,
      )}</div>`;
    } else {
      player.$('.vjs-poster').classList.remove('vjs-transcoding');
      // console.log(player.$('.vjs-loading-spinner'));
      // player.$('.vjs-loading-spinner').hidden = true;
      player.$( // eslint-disable-line
        '.vjs-poster',
      ).innerHTML = '';
    }
  };

  onVideoPlayerReady = player => {
    this.props.playerRef({
      player,
      toggleNotes: this.toggleNotes,
    });
    this.player = player;
    const {
      query,
      lesson,
      videoNotes,
      complete,
      updateState,
      playFrom,
      lang,
    } = this.props;

    const { service } = lesson.youtubeVideoUrl
      ? getVideoId(lesson.youtubeVideoUrl)
      : {};
    if (service === 'youtube') {
      player.removeChild('LoadingSpinner');
    }
    const videoNoteId = _.get(query, 'videoNoteId');
    const videoNote = videoNoteId && _.find(videoNotes, { _id: videoNoteId });

    // if (player && player.tech_&& player.tech_.ytPlayer) {
    //   const progressBar = player.el_.querySelector('.vjs-progress-control');
    //   const iframeBlocker = player.el_.querySelector('.vjs-iframe-blocker');
    //   player.el_.addEventListener('click', (event) => {
    //     const playerState = player.tech_.ytPlayer.getPlayerState();
    //
    //     if (event.target !== progressBar && event.target !== player.el_ && event.target !== iframeBlocker) {
    //       return;
    //     }
    //     if (playerState == YT.PlayerState.ENDED) {
    //       player.currentTime(0);
    //       player.play();
    //     } else if (playerState == YT.PlayerState.PAUSED) {
    //       player.play();
    //     } else if (playerState == YT.PlayerState.PLAYING) {
    //       player.pause();
    //     }
    //   });
    // }

    if (_.get(this.props, 'videoStop')) {
      player.one('play', () => {
        if (_.isFunction(player && player.pause) && !isIOS()) {
          player.pause();
        }
      });
    }

    if (videoNote) {
      player.one('play', () => {
        setTimeout(() => {
          if (_.isFunction(player && player.pause)) {
            player.pause();
            player.currentTime(videoNote.time);
            if (!isIOS()) {
              player.play().catch(err => console.error(err));
            }
          }
        }, 500);
      });
    }

    player.on('timeupdate', () => {
      const percent = (player.currentTime() / player.duration()) * 100;

      if (percent > 90 && !lesson.isCompleted) {
        complete();
      }
    });

    player.on('ended', () => {
      const { course, nextUrl, nextItem, auth } = this.props;

      this.props.handleChangeVideoFullPage(false);

      if (!nextItem || !course._id || !isLoggedIn(auth)) {
        return;
      }

      const timeout = 7000; // todo move it to config
      const startTs = Date.now();
      this.invervalTimer = setInterval(() => {
        const goToNextSectionItemProgress =
          ((Date.now() - startTs) / timeout) * 100;

        if (goToNextSectionItemProgress > 100) {
          clearInterval(this.invervalTimer);
          return;
        }

        this.setState({
          goToNextSectionItemProgress,
        });
      }, 20);

      this.timeoutTimer = setTimeout(() => {
        this.cancelGoToNextSectionItem();
        history.push(
          `/${lang}${
            this.context.organizationSlug
              ? `/${this.context.organizationSlug}`
              : ''
          }/courses/${course.slug}/${nextUrl}`,
        );
      }, timeout);
    });

    this.player.on('qualitySelected', (el, { label }) => {
      this.props.cookies.set('videoQuality', label, {
        path: '/',
        domain: window.App.cookieDomain,
      });
    });

    if (!this.props.loadingVideoNotes) {
      this.updateVideoNotes(videoNotes);
    }

    updateState('isPlayerLoaded', true);
    // const { videoFullPage } = this.state;
    if (playFrom) {
      this.player.currentTime(playFrom);
    }
    const isExternalVideoService = _.includes(['vimeo', 'youtube'], service);

    if (!isIOS()) {
      player
        .play()
        .then(() => {
          if (isExternalVideoService) {
            _.invoke(player.$('.vjs-poster'), 'remove');
          }
        })
        .catch(err => {
          if (isExternalVideoService) {
            _.invoke(player.$('.vjs-poster'), 'remove');
          }
          console.error(err);
        });
    }
  };

  openVideoNotePopover = () => {
    this.player.pause();
    this.setState({
      isAddVideoNoteOpen: true,
      videoNoteTime: this.player.currentTime(),
    });
  };

  handleVideoNotePopoverClose = () => {
    this.setState({ isAddVideoNoteOpen: false });
  };

  cancelGoToNextSectionItem = () => {
    clearTimeout(this.timeoutTimer);
    clearInterval(this.invervalTimer);
    this.setState({
      goToNextSectionItemProgress: 0,
    });
  };

  removeVideoPlayerEvents = () => {
    const { player } = this;
    player.off('timeupdate');
    player.off('ended');
    player.off('play');
    // player.dispose();
  };

  updateVideoNotes = videoNotes => {
    if (_.get(this, 'player.markers.removeAll')) {
      this.player.markers.removeAll();
    }

    if (_.isFunction(_.get(this, 'player.markers'))) {
      this.player.markers({
        markerStyle: {
          width: '7px',
          'border-radius': '30%',
          'background-color': 'red',
        },
        markerTip: {
          display: true,
          text: ({ text }) => text,
          time: ({ time }) => time,
        },
        breakOverlay: {
          display: true,
          displayTime: 8,
          style: {
            width: '100%',
            height: '40px',
            'background-color': 'rgba(0,0,0,0.7)',
            color: 'white',
            'font-size': '17px',
          },
          text: ({ text }) => text,
        },
        onMarkerClick() {},
        onMarkerReached() {},
        markers: _.map(videoNotes, ({ time, text }) => ({
          overlayText: text,
          text,
          time,
        })),
      });
    }

    if (_.get(this, 'player.markers.add')) {
      this.player.markers.add(
        _.map(videoNotes, ({ time, text }) => ({
          overlayText: text,
          text,
          time,
        })),
      );
    }
  };

  toggleNotes = isNotesShown => {
    const { videoNotes } = this.props;
    if (this.player && _.get(this, 'player.markers.removeAll')) {
      this.player.markers.removeAll();

      if (isNotesShown) {
        this.player.markers.add(
          _.map(videoNotes, ({ time, text }) => ({
            overlayText: text,
            text,
            time,
          })),
        );
      }
    }
  };

  hideSnackBar = () => {
    this.setState({ isSnackBarShown: false });
  };

  render() {
    const {
      lesson,
      videoFullPage,
      cookies,
      nextUrl,
      nextItem,
      contentTypeSwitchers,
      lang,
      intl: { formatMessage },
      className,
      offline,
      course,
      isNotesShown,
      isPlayerLoaded,
      auth,
      totalTranscodingJobs,
      thumbnailVimeoImg,
    } = this.props;

    const {
      goToNextSectionItemProgress,
      isSnackBarShown,
      videoNoteTime,
      isAddVideoNoteOpen,
    } = this.state;
    const { whitelabeling, organizationSlug } = this.context;

    const getVideoLoaderUrl = (whitelabeledOptions, pathTo, defaultLoader) => {
      const path = _.get(whitelabeledOptions, `${pathTo}`)
        ? `${this.context.cloudfrontUrl}${_.get(whitelabeling, `${pathTo}`)}`
        : defaultLoader;

      return path;
    };
    const videoLoader =
      organizationSlug && !lesson.isSharedToWhitelabeledOrg
        ? getVideoLoaderUrl(
            whitelabeling,
            'videoLoader',
            `${this.context.cloudfrontUrl}/video-loader.png`,
          )
        : `${this.context.cloudfrontUrl}/video-loader.png`;

    const thumbnail = [
      {
        srcset: videoLoader,
        type: 'image/png',
      },
    ];

    const selected =
      cookies.get('videoQuality') ||
      _.get(
        _.maxBy(lesson.videos, ({ label }) => parseInt(label, 10)),
        'label',
        '1080p',
      );

    const sources = _.map(
      _.sortBy(lesson.videos, ({ label }) => -parseInt(label, 10)),
      ({ label, file: { path, mimetype } }) => ({
        key: path,
        src: `${this.context.cloudfrontUrl}/${path}`,
        type: mimetype,
        label,
        selected: selected === label,
      }),
    );

    const videoJsOptions = {
      autoplay: !isIOS(),
      controls: true,
      speed: true,
      playbackRates: [0.85, 1, 1.3, 1.5, 1.75],
      sources,
      poster: thumbnailVimeoImg || thumbnail[0].srcset,
      thumbnail,
      // responsive: true,
      // fluid: true,
      language: lang,
      playsInline: isIOS(),
      controlBar: {
        children: [
          'playToggle',
          'volumePanel',
          'currentTimeDisplay',
          'progressControl',
          'playbackRateMenuButton',
          'qualitySelector',
          'fullscreenToggle',
        ],
      },
    };

    const { service } = lesson.youtubeVideoUrl
      ? getVideoId(lesson.youtubeVideoUrl)
      : {};

    if (service === 'youtube') {
      videoJsOptions.sources = [
        {
          type: 'video/youtube',
          src: lesson.youtubeVideoUrl,
        },
      ];
      videoJsOptions.youtube = {
        hl: lang,
        ytControls: 2,
        playsinline: !isIOS(),
        start: 1,
      };
      videoJsOptions.controls = false;
      if (isIOS()) {
        videoJsOptions.poster = null;
        videoJsOptions.thumbnail = null;
      }
    }
    if (service === 'vimeo') {
      videoJsOptions.sources = [
        {
          type: 'video/vimeo',
          src: lesson.youtubeVideoUrl,
        },
      ];
      videoJsOptions.vimeo = { playsinline: !isIOS() };
    }
    if (!videoJsOptions.sources.length) {
      videoJsOptions.techOrder = ['html5'];
    }
    const videoNoteIsNotAvailable = isLoggedIn(auth) && course._id;

    return (
      <div
        className={classNames(
          s.lessonVideoContent,
          !contentTypeSwitchers.text && s.fullWidth,
          videoFullPage && s.fullPage,
          videoFullPage && 'full-page-video-wrapper',
          className,
          // !videoNoteIsNotAvailable ? s.videoNoteIsHidden : undefined,
        )}
        onClick={videoFullPage ? e => this.onVideoClick(e) : null}
        onKeyPress={videoFullPage ? e => this.onVideoClick(e) : null}
        role="button"
        tabIndex="-1"
      >
        <NoSsr>
          <VideoPlayer
            onReady={this.onVideoPlayerReady}
            onSetup={this.onVideoPlayerSetup}
            onUnmount={this.onVideoPlayerUnmount}
            key={lesson._id}
            goToNextSection={
              !!goToNextSectionItemProgress &&
              nextItem && (
                <GoToNextSection
                  nextItem={nextItem}
                  nextUrl={nextUrl}
                  goToNextSectionItemProgress={goToNextSectionItemProgress}
                  cancelGoToNextSectionItem={this.cancelGoToNextSectionItem}
                />
              )
            }
            {...videoJsOptions}
          />
        </NoSsr>
        {videoNoteIsNotAvailable &&
          service !== 'vimeo' &&
          service !== 'youtube' && (
            <NoSsr>
              <div className={s.addNoteWrapper}>
                <Button
                  color="primary"
                  size="large"
                  className={classNames(s.addNote)}
                  onClick={this.openVideoNotePopover}
                  buttonRef={node => {
                    this.videoNoteAnchorEl = node;
                  }}
                  disabled={
                    !isPlayerLoaded ||
                    !isNotesShown ||
                    (totalTranscodingJobs &&
                      !_.get(lesson, 'videos.length') &&
                      !lesson.youtubeVideoUrl)
                  }
                  id="add-video-note-btn"
                >
                  <NoteAdd className={s.buttonIcon} />
                  <FormattedMessage {...messages.addNoteLabel} />
                </Button>
              </div>
            </NoSsr>
          )}
        <Snackbar
          open={isSnackBarShown}
          onClose={this.hideSnackBar}
          autoHideDuration={5000}
          message={formatMessage(messages.clickOnVideoToExitFullScreen)}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
        />
        {isLoggedIn(auth) && isAddVideoNoteOpen && course._id && !offline && (
          <VideoNotePopover
            handleVideoNotePopoverClose={this.handleVideoNotePopoverClose}
            videoNoteTime={videoNoteTime}
            videoNoteAnchorEl={this.videoNoteAnchorEl}
            isAddVideoNoteOpen={isAddVideoNoteOpen}
          />
        )}
      </div>
    );
  }
}

export default React.forwardRef((props, ref) => (
  <Video {...props} playerRef={ref} />
));
